import * as React from "react";
import { Container, Spinner } from "native-base";

// import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { currentLanguage } from "../../../translations/CurrentLanguage";

import styles from "./styles";

import EmailFormComponent from "@components/EmailFormComponent";
import CodeInputComponent from "@components/CodeInputComponent";
import AuthCard from "@components/AuthCardComponent";
import translation from "../../../translations/translation";
import LocalizedStrings from "react-native-localization";
let strings = new LocalizedStrings(translation);
class Login extends React.Component {
  render() {
    const LoginComponent =
      this.props.status === "idle" ? (
        <EmailFormComponent
          submitText="Set Pin"
          onSubmit={() => this.props.onSetPin()}
          onPinSecurityStatus={() => this.props.onPinSecurityStatus()}
          onConfirmPinSecurityStatus={() =>
            this.props.onConfirmPinSecurityStatus()
          }
          onNameChange={text => this.props.onNameChange(text)}
          onPinChange={text => this.props.onPinChange(text)}
          onConfirmPinChange={text => this.props.onConfirmPinChange(text)}
          userName={this.props.userName}
          pin={this.props.pin}
          confirmPin={this.props.confirmPin}
          securityPinStatus={this.props.securityPinStatus}
          securityConfirmPinStatus={this.props.securityConfirmPinStatus}
        />
      ) : (
        <Spinner color="#2563eb" />
      );
    strings.setLanguage(currentLanguage().companyLanguage);
    return (
      <Container style={styles.container}>
        <CodeInputComponent
          visible={this.props.verificationVisible}
          onVerify={code => this.props.onVerify(code)}
          onResend={() => this.props.onResend()}
          onClose={() => this.props.onCodeInputClose()}
        />
        <AuthCard
          title={strings.SetOwnerPin}
          subtitle="Create the owner account for this device"
        >
          {LoginComponent}
        </AuthCard>
      </Container>
    );
  }
}

export default Login;
